<template>
    <v-card>
        <v-card-title>Select Item</v-card-title>
        <v-card-text>
            <v-select label="Common Object" :items="$props.commonObjects" return-object item-text="object_name" color="#c42111" v-model="selectedCommonObject" @change="lookupCommonObjectItems" />
            <v-select label="Item" :items="commonObjectItemsList" :disabled="!selectedCommonObject" return-object item-text="item_name" color="#c42111" v-model="selectedCommonObjectItem" />
        </v-card-text>

        <v-divider />
        <v-card-actions>
            <v-btn text color="#ffffff" :disabled="!selectedCommonObjectItem" @click="$emit('details', selectedCommonObjectItem)">Details</v-btn>
            <div class="flex-grow-1"></div>
            <v-btn text color="#ffffff" @click="$emit('cancel')">Cancel</v-btn>
            <v-btn text color="#ffffff" :disabled="!selectedCommonObjectItem" @click="$emit('ok', selectedCommonObjectItem)">Ok</v-btn>
        </v-card-actions>
        
    </v-card>
</template>

<script>
export default {
  name: 'SelectCommonObjectItem',
  props: ['commonObjects'],
  components: {

  },
  data: () => ({
      selectedCommonObject: null,
      commonObjectItemsList: [],
      selectedCommonObjectItem: null,
  }),

  computed: {
  },

  methods: {
      lookupCommonObjectItems: function() {
          let route = (TELSA.apiHost + "commonobjects/itemslist");
          TELSA.loading(true);
          return this.$http.post(route, {args: {commonObjectId: this.selectedCommonObject.object_id}}).then(response => {
              let result = response.body;
              this.commonObjectItemsList = result.common_object_items;
              TELSA.loading(false);
          });
      }
  },

  mounted() {

  }

  
};
</script>
